import { FormCombobox, FormInput, FormSelect, FormTextarea } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import {
  ACADEMIC_YEAR,
  ACTIVITY_TYPE,
  APPLICABLE_GRADES,
  CURRICULUM_TOPIC,
  DESCRIPTION,
  GRADES,
  MODULE,
  SUB_MODULE,
  TOPIC,
  TOPIC_TLM,
  YEAR,
  KIT_NAME,
  KIT_TYPE,
} from "../consts";
import { X } from "lucide-react";
import { capitalize, yearOptions } from "@/lib/utils";

const AddEdit = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isView,
    onCancel,
    isMobile,
    action,
    isEdit,
    activityTypeOptions,
    moduleOptions,
    submoduleOptions,
    gradeOptions,
    tlmTopicOptions,
    kitTypeOptions,
    isLoading: isPending
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6 lg:min-w-[500px] xl:min-w-[730px]">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">
              {isEdit ? "Update" : capitalize(action || "")} Curriculum
            </DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
            <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[100px] px-1">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[25px]">
                <FormCombobox
                  name={APPLICABLE_GRADES}
                  control={form.control}
                  label="Applicable Grades"
                  placeholder="Please enter"
                  error={errors[APPLICABLE_GRADES]?.message}
                  isRequired={requiredFields.includes(APPLICABLE_GRADES)}
                  options={gradeOptions}
                  disabled={isView}
                  multiSelect
                />
                <FormSelect
                  name={MODULE}
                  control={form.control}
                  label="Module"
                  placeholder="Please enter"
                  error={errors[MODULE]?.message}
                  isRequired={requiredFields.includes(MODULE)}
                  options={moduleOptions}
                  disabled={isView}
                  multiSelect
                />
                <FormCombobox
                  name={SUB_MODULE}
                  control={form.control}
                  label="Submodule"
                  placeholder="Please enter"
                  error={errors[SUB_MODULE]?.message}
                  isRequired={requiredFields.includes(SUB_MODULE)}
                  options={submoduleOptions}
                  disabled={isView}
                  multiSelect
                />
                <FormInput
                  name={CURRICULUM_TOPIC}
                  control={form.control}
                  label="Curriculum topic"
                  placeholder="Please enter"
                  error={errors[CURRICULUM_TOPIC]?.message}
                  isRequired={requiredFields.includes(CURRICULUM_TOPIC)}
                  disabled={isView}
                />
                <FormSelect
                  name={ACADEMIC_YEAR}
                  control={form.control}
                  label="Academic Year"
                  placeholder="Please enter"
                  error={errors[ACADEMIC_YEAR]?.message}
                  isRequired={requiredFields.includes(ACADEMIC_YEAR)}
                  options={yearOptions()}
                />
                <FormSelect
                  name={ACTIVITY_TYPE}
                  control={form.control}
                  label="Activity Type"
                  placeholder="Please enter"
                  error={errors[ACTIVITY_TYPE]?.message}
                  isRequired={requiredFields.includes(ACTIVITY_TYPE)}
                  options={activityTypeOptions}
                  disabled={isView}
                />
                <FormSelect
                  name={TOPIC_TLM}
                  control={form.control}
                  label="KIT Name"
                  placeholder="Please enter"
                  error={errors[TOPIC_TLM]?.message}
                  isRequired={requiredFields.includes(TOPIC_TLM)}
                  options={tlmTopicOptions}
                  disabled={isView}
                />
                <div className="md:col-span-2">
                  <FormTextarea
                    name={DESCRIPTION}
                    control={form.control}
                    label="Description"
                    placeholder="Please enter"
                    error={errors[DESCRIPTION]?.message}
                    isRequired={requiredFields.includes(DESCRIPTION)}
                    disabled={isView}
                    className="h-[200px]"
                    maxLength={1000}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-end gap-3 py-3 absolute bottom-0 w-full bg-white pb-[25px] z-[3]">
              <Button variant="outline" type="button" onClick={onCancel}>
                Cancel
              </Button>
              {isView ? (
                <></>
              ) : (
                <Button type="submit">{isEdit ? "Update" : "Submit"}</Button>
              )}
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default AddEdit;
